import { useCallback, useRef, useState } from 'react'

import { useManagedTimers } from '@hooks/useManagedTimers'

type TPulseState = {
    key: string | null
    version: number
}

const PULSE_DURATION_MS = 4000

export const usePulseHighlight = () => {
    const { clearManagedTimeout, setManagedTimeout } = useManagedTimers()
    const timeoutID = useRef<ReturnType<typeof setTimeout> | null>(null)
    const [pulseState, setPulseState] = useState<TPulseState>({ key: null, version: 0 })

    const triggerPulse = useCallback((key: string) => {
        clearManagedTimeout(timeoutID.current)

        setPulseState((prev) => ({
            key,
            version: prev.version + 1,
        }))

        timeoutID.current = setManagedTimeout(() => {
            setPulseState((prev) => ({ ...prev, key: null }))
            timeoutID.current = null
        }, PULSE_DURATION_MS)
    }, [clearManagedTimeout, setManagedTimeout])

    const getPulseClassName = useCallback((key: string) => {
        if (pulseState.key !== key) return ''

        return pulseState.version % 2 === 0 ? 'pulse_highlight_a' : 'pulse_highlight_b'
    }, [pulseState.key, pulseState.version])

    return {
        triggerPulse,
        getPulseClassName,
        activePulseKey: pulseState.key,
    }
}
